<div class="flex flex-col h-full">

  <div mat-dialog-title class="flex flex-row items-center
                               pt-6 pl-6 pr-6 pb-4 m-[unset]">
    <div class="flex flex-row justify-center items-center
                 w-[40px] h-[40px] rounded-[8px]
                 bg-green-90 text-green-10">
      <mat-icon svgIcon="batch_modify_location_groups"></mat-icon>
    </div>
    <span class="ml-4
                 text-neutral-10 text-headline-small">
    {{ 'Transfer locations (' + data.locations.length + ')' }}</span>
  </div>

  <mat-dialog-content id="showDifferencesContent"
                      class="flex flex-col h-full
                             m-[unset] p-[unset]">
    <span class="text-neutral-30 text-body-large
                 pl-6">
    Select business groups to add or remove locations.</span>
    <div id="checkcircleWrapper" class="flex flex-col h-full
                                        pt-2 pl-6 pr-6 pb-2 mt-2 mb-2">
      @for (grp of data.gbpGroups; track grp) {
        <div
            class="h-[32px]
                   flex items-center">
          <mat-checkbox class="checkcircle"
                        [checked]="locationGrpsState[grp['gmbAccountId']]['newState']
                        === groupStatesEnum.CHECKED || locationGrpsState[grp['gmbAccountId']]['newState']
                        === groupStatesEnum.USER_CHECKED"
                        [indeterminate]="locationGrpsState[grp['gmbAccountId']]['newState']
                        === groupStatesEnum.INDETERMINATE"
                        [class.checkcircle-outline]="locationGrpsState[grp['gmbAccountId']]['newState']
                        === groupStatesEnum.CHECKED"
                        [class.remove]="locationGrpsState[grp['gmbAccountId']]['newState']
                        === groupStatesEnum.USER_UNCHECKED"
                        (click)="determineNewStateAndGeneratePayload(grp['gmbAccountId'])">
            <span class="text-neutral-10 text-body-medium">{{ grp['accountName'] }}</span>
          </mat-checkbox>
        </div>
      }
    </div>

    @if (areLocationsWithoutGrps()) {
      <div class="bg-orange-80
                  p-3 ml-6 mr-6 mb-6
                  rounded-[4px]
                  flex flex-row">
        <mat-icon class="text-orange-10 pr-3" svgIcon="report_problem"></mat-icon>
        <div class="flex flex-col
                    text-orange-10 text-body-medium">
          <span>Each location has to belong to a business group.</span>
          <span>Please checkmark at least 1 business group.</span>
        </div>
      </div>
    }

  </mat-dialog-content>

  <mat-dialog-actions class="justify-end min-h-[unset]
                             mb-0 pb-6 pl-6 pr-6 pt-0">
    <button matButton="outlined"
            tabindex="-1"
            [disabled]="loading"
            (click)="dialogRef.close()">{{ 'CANCEL' | translate }}
    </button>
    <button mat-flat-button color="primary"
            (click)="transfer()"
            tabindex="-1"
            [disabled]="loading || !isTransferPossible()"
            class="flex flex-row items-center justify-center">
      <span>
        @if (loading) {
          <mat-spinner id="spinner" [diameter]="18"></mat-spinner>
        }
        @if (!loading) {
          <span>Transfer</span>
        }
      </span>
    </button>
  </mat-dialog-actions>

</div>
